import { useEffect, useState } from "react";

const CACHE = "soulumo-offline-audio-v1";

// Keeps one audio file on the device (Cache Storage) so it plays with no signal and no re-streaming.
export const useOfflineAudio = (url) => {
  const [blobUrl, setBlobUrl] = useState(null);
  const [state, setState] = useState("idle"); // idle | saving | saved | error
  useEffect(() => {
    let alive = true;
    let made = null;
    if (!url || !("caches" in window)) return undefined;
    caches.open(CACHE).then((c) => c.match(url)).then(async (hit) => {
      if (!hit || !alive) return;
      made = URL.createObjectURL(await hit.blob());
      if (alive) { setBlobUrl(made); setState("saved"); }
    }).catch(() => {});
    return () => { alive = false; if (made) URL.revokeObjectURL(made); };
  }, [url]);
  const save = async () => {
    if (!("caches" in window)) { setState("error"); return; }
    setState("saving");
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(String(res.status));
      const cache = await caches.open(CACHE);
      await cache.put(url, res.clone());
      setBlobUrl(URL.createObjectURL(await res.blob()));
      setState("saved");
    } catch { setState("error"); }
  };
  const remove = async () => {
    await caches.open(CACHE).then((c) => c.delete(url)).catch(() => {});
    setBlobUrl(null); setState("idle");
  };
  return { blobUrl, state, save, remove, supported: typeof window !== "undefined" && "caches" in window };
};
